module.exports = __webpack_public_path__ + "img/amex_logo.527704a6.svg";